import styled from 'styled-components';
import { horizontalSpace, verticalSpace } from '@doltech/utils/lib/css-style';
import * as React from 'react';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { ButtonSize } from '@doltech/ui/lib/figma/Button/ButtonSize/ButtonSize';
import { ButtonContentGeneral } from '@doltech/ui/lib/figma/Button/ButtonContentGeneral/ButtonContentGeneral';
import { ButtonStyles } from '@doltech/ui/lib/figma/Button/ButtonStyles/ButtonStyles';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { IconSystemV2StatusCheck2 } from '@doltech/icons/SystemV2/IconSystemV2StatusCheck2';

const Container = styled.div`
  ${verticalSpace(16)};
  padding: 32px 40px;
  background-color: ${colorsV2.purple5};
  border-radius: 16px;
  border: 1px solid ${colorsV2.purple10};
  text-align: center;
`;

const Action = styled.div`
  display: flex;
  justify-content: center;

  .button {
    width: max-content;
  }
`;
const Status = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${horizontalSpace(4)};

  ${fromScreen(768)} {
    ${horizontalSpace(8)};
  }
`;

interface CardFinishConfirmProps {
  onClick?: () => void;
  isConfirmRead?: boolean;
}


export const CardFinishConfirm = (props: CardFinishConfirmProps) => {
  const { isConfirmRead, onClick } = props;
  if (isConfirmRead) {
    return (
      <Container>
        <ResponsiveTypography.Paragraph variant="regular/16-28" color="gray180">
          Bạn đã đọc xong bài lý thuyết này. Làm thêm các bài tập liên quan để củng cố kiến thức đã học được nhé!
        </ResponsiveTypography.Paragraph>
        <Status>
          <IconSystemV2StatusCheck2 color="green100" size={16}/>
          <ResponsiveTypography.Paragraph color="green100" variant="medium/14-20">
            Đã đọc
          </ResponsiveTypography.Paragraph>
        </Status>
      </Container>
    );
  }
  return (
    <Container>
      <ResponsiveTypography.Paragraph variant="regular/16-28" color="gray180">
        Bạn đã đọc hiểu toàn bộ bài lý thuyết trên chưa? Hãy đánh dấu đã đọc để lưu lại quá trình học nhé!
      </ResponsiveTypography.Paragraph>
      <Action>
        <div className="button">
          <ButtonStyles
            color="purple"
            colorStyle="bold"
            transparent={false}
            onClick={onClick}
            content={
              <ButtonSize
                size="large"
                verticalPadding
                content={
                  <ButtonContentGeneral
                    text="Đánh dấu đã đọc"
                  />
                }
              />
            }
          />
        </div>
      </Action>
    </Container>
  );
};
